/**
 * Definition der Pots 
 * @class constant_v3sPots
 * @memberOf v3sWbtPlayerApp:model
 * @param NONE - alle Fragen werden zufällig ohne Beachtung der Statistik gezogen
 * @param QUIZ - Fragen mit falschen Antworten werden öfters gezogen
 * @param PAUK - nach 1 korrekten Antwort werden die Fragen nicht mehr gezogen
 */
angular.module('v3sWbtPlayerApp').constant('v3sPots', {
    // "" - keine Antwort
    // "0" - falsche Antwort
    // "1" - korrekte Antwort
    // "011" - 1 falsche und 2 korrekte Antworten

    NONE: [
        { statistic: /.*/ } //keine bzw. alle mögliche Antworten z. B.: "","1","0","0101010"
    ],
    QUIZ: [
         { statistic: /0+$/, maxPercent: 0.5 }, // min. 1 letzte falsche Antwort (max. 50% der Fragen) z. B.: "0","10110","0000"
         { statistic: /^$/ }, // keine Antwort z. B.: ""
         { statistic: /1+$/ }, // min. 1 letzte korrekte Antwort z. B.: "1","01","010101111"
         { statistic: /0+$/ } // aus 1. Pot nachfüllen, falls andere Antworten nicht ausreichen
    ],
    PAUK: [
        { statistic: /^0*$/ } // keine Antwort oder nur falsche Antworten z. B.: "","","0","0000"
    ]
});